import styled from 'styled-components'

export const S_FeeEditor = styled.div`
  min-width: 800px;
  .form-row-label {
    min-width: 400px;
  }
  .warning {
    margin-top: 16px;
    margin-bottom: 16px;
    font-weight: bold;
    max-width: 750px;
    margin-left: auto;
    margin-right: auto;
  }
  .table-wrapper {
    max-width: 300px;
    min-width: 300px;
    margin-top: 16px;
    margin-bottom: 16px;
    max-height: 800px;
    overflow-y: scroll;
  }

  .table-title {
    font-size: 16px;
    min-height: 25px;
    font-weight: 600;
  }

  .table-caption {
    font-size: 13px;
    margin-top: 5px;
  }

  .table-save {
    display: flex;
    justify-content: space-between;
    min-width: 100%;
  }
  .save-wrapper {
    margin-top: 10px;
    &:only-child {
      margin-left: auto;
    }
  }
  .error {
    margin-bottom: 8px;
  }
`
